import { acceptHMRUpdate, defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
  persist: {
    storage: persistedState.cookiesWithOptions({
      maxAge: 60 * 60 * 24 * 365,
    }),
  },
  
  state: () => ({
    id: null,
    token: null,
    email: null,
    phone: null,
    firstName: null,
    lastName: null,
    allowLocation: null,
    latitude: null,
    longitude: null,
  }),

  getters: {
    authed() {
      return !!this.id && !!this.token
    },
    hasLocation() {
      return this.allowLocation && !!this.latitude && !!this.longitude
    }
  },

  actions: {
    reset() {
      this.$reset()
    },

    logOut() {
      const email = this.email
      this.$reset()
      this.email = email
    },

    resetLocation() {
      this.allowLocation = null
      this.latitude = null
      this.longitude = null
    },

    async getLocation() {
      try {
        const response = await useGetGeoLocationAsync()
        this.allowLocation = true
        this.latitude = response.latitude
        this.longitude = response.longitude
      } catch (error) {
        console.error('Error getting location:', error.message || error)
        this.allowLocation = false
        this.latitude = null
        this.longitude = null
      }
      return true
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useUserStore, import.meta.hot))
}
